import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataDivision } from '../types/masterdata-entities';
import { keyName } from './shared';

export const MASTERDATA_DIVISION = defineMasterdataEntity<MasterdataDivision>({
  name: 'division',
  responseKey: 'divisions',
  displayWith: (d) => keyName(d.key, d.name),
  secondaryWith: (d) => d.description2,
  icon: 'fa-regular fa-layer-group',
  title: 'Bereichssuche',
  label: 'Bereich',
  placeholder: 'Bereich suchen...',
  columns: [
    {
      label: 'Bereich',
      type: 'entity',
      icon: 'fa-regular fa-layer-group',
      value: (e) => keyName(e.key, e.name),
      secondary: (e) => e.description2,
    },
    { label: 'Schlüssel', type: 'text', value: (e) => e.key },
    { label: 'Bezeichnung', type: 'text', value: (e) => e.name },
    { label: 'Bezeichnung 2', type: 'text', value: (e) => e.description2 },
    { label: 'Bezeichnung 3', type: 'text', value: (e) => e.description3 },
    { label: 'Bezeichnung 4', type: 'text', value: (e) => e.description4 },
  ],
});
